import { resetWhenRouterChange } from '@ui/utils/zustandMiddleware';
import type { EthersError } from '@veno-app/sdk';
import { create } from 'zustand';

import type { CollectionNft } from '../types';

export enum STEP {
  default,
  confirming,
  pending,
  success,
  failed,
}

type GardenNftMode = 'STAKE' | 'UNSTAKE';

export type UseGardenNftStore = {
  isOpen: boolean;
  selectedTokens: CollectionNft[];
  setSelectedTokens: (tokens: CollectionNft[]) => void;
  mode: GardenNftMode;
  onOpen: (mode?: GardenNftMode) => void;
  onClose: () => void;
  step: STEP;
  setStep: (step: STEP) => void;
  error: EthersError | null;
  numberTransactionSteps: number;
  setNumberTransactionSteps: (n: number) => void;
  currentTransactionStep: number;
  setCurrentTransactionStep: (n: number) => void;
};

export const useGardenNftDrawerStore = create(
  resetWhenRouterChange<UseGardenNftStore>((set) => ({
    isOpen: false,
    mode: 'STAKE',
    numberTransactionSteps: 1,
    currentTransactionStep: 1,
    setNumberTransactionSteps: (numberTransactionSteps) =>
      set({ numberTransactionSteps }),
    setCurrentTransactionStep: (currentTransactionStep) =>
      set({ currentTransactionStep }),
    onOpen: (mode?: GardenNftMode) => {
      set({
        isOpen: true,
        mode: mode ?? 'STAKE',
      });
    },
    selectedTokens: [],
    step: STEP.default,
    setSelectedTokens: (selectedTokens) => {
      set({ selectedTokens });
    },
    onClose: () => {
      useGardenNftDrawerStore.getState().$$resetData?.();
    },
    setStep: (step) => {
      set({
        step,
      });
    },
    error: null,
  })),
);
